import { TOOL_ID } from '@/consts/configs';
import {
  readHiddenListFile,
  writeHiddenListFile,
} from '@/requests/cloud-storage/hiddenListFile';

import type { OnboardingRecord } from '../types';

export const ONBOARDING_FILE = 'genai-onboarding.json';

export const ONBOARDING_ATTR = 'genai~onboarding';

/**
 * Pinned to `TOOL_ID` rather than `store.toolId`, which a `presetJsonUrl`
 * deeplink can repoint at another drive folder — the record has to stay in one
 * place across every session.
 */
export const readOnboardingRecord =
  async (): Promise<OnboardingRecord | null> => {
    const stored = await readHiddenListFile({
      toolId: TOOL_ID,
      fileName: ONBOARDING_FILE,
      attribute: ONBOARDING_ATTR,
    });

    if (!stored) return null;

    return {
      categories: stored.values,
      fileId: stored.fileId,
      isCompleted: stored.fileId !== null,
    };
  };

export const saveOnboardingRecord = ({
  categories,
  fileId,
}: {
  categories: string[];
  fileId: string | null;
}): Promise<{ fileId: string | null } | null> =>
  writeHiddenListFile({
    toolId: TOOL_ID,
    fileName: ONBOARDING_FILE,
    attribute: ONBOARDING_ATTR,
    values: categories,
    fileId,
  });
